import {
    capitalize,
    dashesIfNull,
    replaceBreakLine,
    dateTime,
    nullToEmpty,
    showBool,
    showIcon,
    toCurrency,
    byteToHumanFormat
} from './Filters';

export default {
    install(app) {
        app.config.globalProperties.$capitalize = capitalize;
        app.config.globalProperties.$dashesIfNull = dashesIfNull;
        app.config.globalProperties.$replaceBreakLine = replaceBreakLine;
        app.config.globalProperties.$dateTime = dateTime;
        app.config.globalProperties.$nullToEmpty = nullToEmpty;
        app.config.globalProperties.$showBool = showBool;
        app.config.globalProperties.$showIcon = showIcon;
        app.config.globalProperties.$toCurrency = toCurrency;
        app.config.globalProperties.$byteToHumanFormat = byteToHumanFormat;
    }
};
